import React from 'react';

import { PickupAddressCheckbox } from './pickup-address-checkbox';
import { WalletBillingAddress } from './wallet-billing-address';
import { WalletPickupAddress } from './wallet-pickup-address';
import { FORM_REQUIREMENTS } from '../../../../utilities/constants';
import { useWalletRegistrationModalContext } from '../../contexts/wallet-registration-modal-context';
import { RequirementGuard } from '../requirement-guard';

/**
 * @param {object} props
 * @param {'personal' | 'business'} props.accountType - The account type (PERSONAL or BUSINESS)
 * @param {(requirement: string, isValid: boolean) => void} props.markFormComplete - Function to mark form completion status
 * @returns {JSX.Element}
 */
export const BillingAndPickup = ({ accountType, markFormComplete }) => {
  const { isPickupSameAsBilling, setIsPickupSameAsBilling } = useWalletRegistrationModalContext();
  return (
    <>
      <RequirementGuard requirements={FORM_REQUIREMENTS.BILLING_ADDRESS}>
        <WalletBillingAddress accountType={accountType} isPickupSameAsBilling={isPickupSameAsBilling} markFormComplete={markFormComplete} />
        <RequirementGuard requirements={FORM_REQUIREMENTS.PICKUP_ADDRESS}>
          <PickupAddressCheckbox isPickupSameAsBilling={isPickupSameAsBilling} setIsPickupSameAsBilling={setIsPickupSameAsBilling} />
        </RequirementGuard>
      </RequirementGuard>
      <RequirementGuard requirements={FORM_REQUIREMENTS.PICKUP_ADDRESS}>
        {!isPickupSameAsBilling && <WalletPickupAddress accountType={accountType} markFormComplete={markFormComplete} />}
      </RequirementGuard>
    </>
  );
};
